export default {
  error: {},
  info: {},
  success: {},
  isAPIProgress: false,
  isReviewVisible: false,
  isAddReviewVisible: false,
  isSubmittingReview: false,
  reviews: [],
  isFetchingReviews: false,
  isSubmittingVote: false,
};
